import React from 'react';
import { Col, Row } from 'antd';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import Page403 from '@page/Common/403/403';
import { usePermission } from '@contexts/Auth/UsePermission';
import SimCardList from './components/SimCardList';

const SimCards = () => {
  const { device } = usePermission();

  if (!device.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath="/dashboard"
          routeSegments={[{ name: 'Quản lý SIM', path: '/sim-cards' }]}
        />
      </div>
      <Row>
        <Col span={24}>
          <SimCardList />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default SimCards;
